<template>
  <b-card class="lesson-card">
    <!-- ...tu contenido... -->
    <b-collapse id="collapse-4" v-model="visible" class="mt-2">
      <b-card class="lesson-content">
        <div class="activities-container">
          <!-- Actividades en clase -->
          <div class="class-activities">
            <h5>
              <span class="image-container image-container-activities-class"></span>
              {{$t('academy.in-class-activities')}}
            </h5>
            <ul>
              <li
                v-for="(classActivity, index) in lesson.classActivities"
                :key="index"
              >
                <b-link
                  class="activity-link"
                  href="#"
                  @click.prevent="selectActivity(classActivity.id)"
                  @contextmenu.prevent="openInNewTab(classActivity.id)"
                >
                  <b-icon icon="star-fill"></b-icon> {{ classActivity.name }}
                </b-link>
              </li>
            </ul>
          </div>
          <div class="divider"></div>
          <!-- Actividades en casa -->
          <div class="home-activities" v-if="lesson.homeActivities && lesson.homeActivities.length > 0">
            <h5>
              <span class="image-container image-container-activities-home"></span>
              {{$t('academy.in-home-activities')}}
            </h5>
            <ul>
              <li
                v-for="(homeActivity, index) in lesson.homeActivities"
                :key="index"
              >
                <b-link
                  class="activity-link"
                  href="#"
                  @click.prevent="selectActivity(homeActivity.id)"
                  @contextmenu.prevent="openInNewTab(homeActivity.id)"
                >
                  <b-icon icon="star-fill"></b-icon> {{ homeActivity.name }}
                </b-link>
              </li>
            </ul>
          </div>
        </div>
      </b-card>
    </b-collapse>
    <!-- Modal para cursos premium -->
    <PremiumBlockModal v-model="showPremiumModal" />
  </b-card>
</template>
<script>
import PremiumBlockModal from './PremiumBlockModal.vue';
export default {
  name: "LessonCollapse",
  props: {
    description:{
      type: String
    },
    moduleNumber: {
      type: Number,
      required: true,
    },
    lessonNumber: {
      type: Number,
      required: true,
    },
    lesson: null,
    modality: {
      type: String,
      default: 'free'
    },
  },
  components:{
    PremiumBlockModal
  },
  data() {
    return {
      visible: true,
      showPremiumModal: false,
    };
  },
  methods: {
    selectActivity(activityId) {
      if (this.modality === 'premium') {
        this.showPremiumModal = true;
        return;
      }
      
      // Emitir el evento
      this.$emit('activity-selected', activityId);
      
      // Construir la URL de la nueva pestaña
      const route = this.$router.resolve({
        name: 'guide',
        params: {
          activityId,
          lang: this.$i18n.locale
        }
      });
      
      // Abrir en nueva pestaña (igual que openInNewTab)
      window.open(route.href, '_blank');
    },
    openInNewTab(activityId) {
      if (this.modality === 'premium') {
        this.showPremiumModal = true;
        return;
      }
      
      // Construir la URL de la nueva pestaña
      const route = this.$router.resolve({
        name: 'guide',
        params: {
          activityId,
          lang: this.$i18n.locale
        }
      });
      
      // Abrir en nueva pestaña
      window.open(route.href, '_blank');
      
      // Emitir el evento (opcional, por si necesitas hacer algo más)
      this.$emit('activity-selected', activityId);
    },
  },
};
</script>

<style scoped>
p {
  padding-left: 3rem;
}
.btn:focus,
.btn.focus {
  outline: 0;
  box-shadow: none;
}
.lesson-card {
  margin-bottom: 20px;
  border-radius: 10px;
  border: 1px solid #dcdcdc;
}

.lesson-card span {
  gap: 1em;
}

.lesson-toggle {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 10px;
  text-align: left;
  font-weight: bold;
  color: #333;
}

.lesson-toggle span {
  display: flex;
  align-items: center;
}

.lesson-toggle b-icon {
  margin-right: 8px;
}

.lesson-content {
  padding: 15px;
  border-radius: 0 0 10px 10px;
}

.activities-container {
  display: flex;
  justify-content: space-between;
}

.class-activities,
.home-activities {
  width: 48%;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

li .b-icon.bi {
  margin-right: 10px;
}

.divider {
  width: 1px;
  background-color: #dcdcdc;
  margin: 0 10px;
}

.image-container {
  display: inline-block;
  background-size: cover;
  background-repeat: no-repeat;
  width: 23px;
  height: 23px;
  background-position: center center;
  vertical-align: middle;
  margin-right: 8px;
}
.image-container-activities-class {
  background-image: url("@/assets/imgs/academy/16.png");
}
.image-container-activities-home {
  background-image: url("@/assets/imgs/academy/17.png");
}

/* Estilos para los enlaces de actividades */
.activity-link {
  color: #000; /* Negro por defecto */
  text-decoration: underline; /* Sin subrayado */
  transition: color 0.3s ease, transform 0.3s ease, text-decoration 0.3s ease; /* Transiciones suaves */
  cursor: pointer;
}

.activity-link:hover {
  color: #1034a6; /* Azul cuando se pasa el mouse */
  text-decoration: underline; /* Subrayado al hacer hover */
  transform: translateX(3px); /* Movimiento suave a la derecha */
}

.activity-link::after {
  content: "";
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.5;
  transition: opacity 0.3s ease;
}

.activity-link:hover::after {
  opacity: 0.7;
}
</style>